import React from "react";
import BlankFormButterfly from "../../../../assets/images/blank_form_butterfly.png";

// Шапка индивидуальной (пустой) анкеты (Figma 11691-46635): карточка с бабочкой +
// название под ней по центру. Общая для страницы ЗАПОЛНЕНИЯ и страницы РЕЗУЛЬТАТА
// (оба заполнили). Классы глобальные — в InsightQuestionnaireFormPage/style.scss.
export default function BlankFormHead({ name }) {
  return (
    <div className="insight-questionnaire-form-page__blank-head">
      <div className="insight-questionnaire-form-page__blank-card">
        <img src={BlankFormButterfly} alt="" />
      </div>
      <div className="insight-questionnaire-form-page__blank-title">{name}</div>
    </div>
  );
}
